import { InjectionToken, WritableSignal } from '@angular/core';
import { UserFormat } from '@agilox/common';

export const USER_FORMAT = new InjectionToken<WritableSignal<UserFormat>>('UserFormat');
